import React, { useEffect } from "react";
import { Provider, useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Switch, useHistory } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";

import store from "./redux/store";

import ROUTER from "./constants/router";

import AppLayout from "./components/AppLayout";
import Login from "./containers/AppLayout/Login";
import { getWebSocketService } from "./utils/websocketService";
import Cookies from "js-cookie";

import "./index.css";
import theme from "./theme";

// Component để kết nối WebSocket và lắng nghe lệnh logout từ backend
function WebSocketListener() {
  const history = useHistory();

  useEffect(() => {
    // Lấy access token từ cookies hoặc localStorage
    const getAccessToken = () => {
      // Thử lấy từ cookie trước (token backend)
      const accessToken = Cookies.get("AccessToken");
      if (accessToken) {
        return accessToken;
      }

      // Fallback: lấy Microsoft token từ ms_account
      const msAccountStr = localStorage.getItem("ms_account");
      if (msAccountStr) {
        try {
          const msAccount = JSON.parse(msAccountStr);
          if (msAccount.token) {
            return msAccount.token;
          }
        } catch (e) {
          // console.error("❌ Lỗi parse ms_account:", e);
        }
      }

      return null;
    };

    const accessToken = getAccessToken();

    if (!accessToken) {
      // console.log("⚠️ Không tìm thấy access token, skip WebSocket connection");
      return;
    }

    // Lấy sid từ localStorage
    const sid = localStorage.getItem("ms_sid");

    // console.log("🟢 Khởi tạo WebSocket connection với token");

    // Callback khi nhận lệnh logout từ backend
    const handleLogoutCommand = (data) => {
      // console.log("🔴 Nhận lệnh logout từ backend:", data);

      // Xóa tất cả dữ liệu đăng nhập
      Cookies.remove("AccessToken");
      Cookies.remove("RefreshToken");
      localStorage.removeItem("ms_account");
      localStorage.removeItem("pkce_verifier");
      localStorage.removeItem("ms_sid");
      sessionStorage.clear();

      // Hiển thị thông báo (optional)
      // alert('Bạn đã đăng xuất khỏi Microsoft Outlook. Phiên đăng nhập của bạn đã kết thúc.');

      // Redirect về trang login
      window.location.href = ROUTER.LOGIN;
    };

    // Kết nối WebSocket với access token và sid
    const wsService = getWebSocketService();
    wsService.connect(accessToken, sid, handleLogoutCommand);

    // Cleanup khi component unmount
    return () => {
      // console.log("🔴 Đóng WebSocket connection");
      wsService.disconnect();
    };
  }, [history]);

  return null;
}

function App({ instance }) {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Router>
          <WebSocketListener />
          <Switch>
            <Route exact path={ROUTER.LOGIN} component={Login} />
            <Route path={ROUTER.HOME} component={AppLayout} />
          </Switch>
        </Router>
      </Provider>
    </ThemeProvider>
  );
}

export default App;

